// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__wBQMs","modal":"Modal_modal__wscnj","slide-down":"Modal_slide-down__oxJ3c"};